import actions from '../../actionTypes';

export default (orgCount) => {
  return {
    type: actions.GET_ORGS,
    orgCount
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/getOrgs.js